// Today's View CRM Details pop-up (ViewAllotedCrmDetailsModal) reads the booking as the
// selectedAllotmentObject of today's CRM lists. This builds it from a row of getOldCrmRow()
// (Services/Crm2List). Used by the CRM 2.0 page ⋮ menu and the CRM 2.0 bell (M1-F8).
export function crmDetailsObject(row) {
  return {
    ...row,
    allotmentPaymentId: {
      paidAmt: row.paidamt,
      unitCost: row.unitcost,
      allotmentPaymentId: row.allotment_payment_id,
      applicationApiRes: row.application_api_res,
      "100AmrRes": row.amr_100_res,
      "100B2bRes": row.b2b_100_res,
      GstAmrRes: row.gst_amr_res,
      gstB2bRes: row.gst_b2b_res,
      SdrB2bRes: row.sdr_b2b_res,
      WithoutTdsRes: row.without_tds_res,
    },
  };
}
